import React, {useState} from 'react';
import { Row, Col } from "olive-react-myoneui";
import Form from "olive-react-myoneui/lib/Form";
import Button from "olive-react-myoneui/lib/Button";
import ModalCommon from "../../ModalCommon";

const ModalFile = ({ showModal, closeModalFile, documentTypeSection, fileDetail, updateDocument }) => {
    const [errorMessage, setErrorMessage] = useState('');
    const [formData, setFormData] = useState({
        itemName:fileDetail.itemName,
        categoryId: fileDetail.itemDocumentType,
        sectionId: fileDetail.itemSectionType,
        tagName: fileDetail.itemDocumentTags
    });


    if(!showModal || !fileDetail) return null;
    // Handle input change
    const handleInputChange = (e) => {
        const {name, value} =  e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
        if(name === "itemName") {
            setErrorMessage('');
            if(value === ""){
                setErrorMessage('File name is required');
            }
        }
    };

    const handleSaveFile = (e) => {
        e.preventDefault();
        if(errorMessage !== ''){
            return;
        }
        formData.categoryName   = documentTypeSection.category[formData.categoryId];
        formData.sectionName    = documentTypeSection.section[formData.sectionId];
        formData.itemType       = '1';
        updateDocument(formData, fileDetail);
    };


    const handleAddSection = (newCategory) => {
        console.log("New Section Added:", newCategory);
    };
    
    return (
        <ModalCommon
            backdrop="static"
            show={showModal}
            onClose={closeModalFile}
            title="File Details"
            className="myk__stu-question-modal"
            backdropOption="static"
        >
            <Form>
                <Row>
                    <Col xl={12} className="text-start">
                        <Form.Group className="mb-3" controlId="formGroupFileName">
                            <Form.Label>File Name</Form.Label>
                            <Form.Control name="itemName" value={formData.itemName} type="text" placeholder="Enter File name" onChange={handleInputChange} />
                            {errorMessage && <p className="text-danger mt-2">{errorMessage}</p>}
                        </Form.Group>
                    </Col>
                    <Col className="text-start" xl={12}>
                        <Form.Group className="mb-3" controlId="formGroupCategory">
                            <Form.Label>Category</Form.Label>
                            <select
                                className="w-full p-2"
                                value={formData.categoryId}
                                onChange={handleInputChange}
                                name="categoryId"
                                >
                                {Object.entries(documentTypeSection.category).map(([key, value]) => (
                                    <option key={key} value={key}>
                                    {value}
                                    </option>
                                ))}
                            </select>
                        </Form.Group>
                    </Col>
                    <Col className="text-start" xl={12}>
                        <Form.Group className="mb-3" controlId="formGroupSection">
                            <Form.Label>Section</Form.Label>
                            <select
                                className="w-full p-2"
                                value={formData.sectionId}
                                name="sectionId"
                                onChange={handleInputChange}
                                >
                                {Object.entries(documentTypeSection.section).map(([key, value]) => (
                                    <option key={key} value={key}>
                                    {value}
                                    </option>
                                ))}
                            </select>
                        </Form.Group>
                    </Col>
                    <Col xl={12} className="text-start">
                        <Form.Group className="mb-3" controlId="formGroupAddTags">
                            <Form.Label>Tags</Form.Label>
                            <Form.Control 
                                type="text"
                                placeholder="Add tags"
                                value={formData.tagName}
                                name="tagName"
                                onChange={handleInputChange}
                            />
                        </Form.Group>
                    </Col>
                </Row>  
                <Row>
                    <Col className="text-end mt-3">
                        <Button variant="default" onClick={closeModalFile}>Cancel</Button>
                        <Button variant="primary" className="btn-round" onClick={handleSaveFile} type="submit">Update</Button>
                    </Col>
                </Row>
            </Form>
        </ModalCommon>
    );
}

export default ModalFile;